<template>
  <div class="space-y-4">
    <div>
      <CreateContactRequestMedia
        :contact-request-id="contactRequestId"
        :on-data="processData"
        :on-submit="notifyActive"
        :on-submitted="notifyInactive"
        @created="$emit('created')"
      />
    </div>
    <div>
      <BaseButton ghost :disabled="active" @click="$emit('created')"> Cancel </BaseButton>
    </div>
  </div>
</template>

<script>
import CreateContactRequestMedia from './addAttachmentTabbedForm/CreateContactRequestMedia.vue';

export default {
  components: {
    CreateContactRequestMedia,
  },
  props: {
    contactRequestId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    processData(data) {
      if (data instanceof FormData) {
        data.append('contactRequestId', this.contactRequestId);
      } else if (typeof data === 'object' && data !== null) {
        Object.assign(data, { contactRequestId: this.contactRequestId });
      }

      return data;
    },
    notifyActive() {
      this.active = true;
    },
    notifyInactive() {
      this.active = false;
    },
  },
};
</script>
